import React from 'react';

const Social = () => {
    return (
        <div className='home_social'>
            <a href="https://wa.me/+8801687026563"
                className='home_social-icon'
                target='_blank'
                rel="noopener noreferrer"
            >
                <i class="uil uil-whatsapp"></i>
            </a>
            <a href="https://www.linkedin.com/in/farhan-razy/" className='home_social-icon' target='_blank' rel="noopener noreferrer">
                <i class="uil uil-linkedin-alt"></i>

            </a>
            <a href="https://github.com/RAZYANIK" className='home_social-icon' target='_blank' rel="noopener noreferrer">
                <i class="uil uil-github-alt"></i>
            </a>
        </div>
    );
};

export default Social;